import type { InputHTMLAttributes } from 'react';

import { cx } from '../../lib/cx';
import { Icon } from '../Icon';

import styles from './SearchField.module.css';

export interface SearchFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'aria-label'> {
  /** What is being searched: the field's name for assistive technology. */
  label: string;
  /** Called when the microphone is pressed. Without it there is no microphone. */
  onVoice?: () => void;
  /** Name of the microphone button. */
  voiceLabel?: string;
}

/** A search box, optionally with voice input. 44, 48 or 52 px high, by device. */
export function SearchField({
  label,
  onVoice,
  voiceLabel = 'Voice input',
  className,
  disabled,
  ...rest
}: SearchFieldProps) {
  return (
    <div className={cx(styles.field, disabled && styles.disabled, className)}>
      <Icon name="search" size="var(--hs-field-icon)" className={styles.lead} />
      <input type="search" aria-label={label} disabled={disabled} className={styles.input} {...rest} />
      {onVoice ? (
        <button
          type="button"
          className={styles.voice}
          aria-label={voiceLabel}
          title={voiceLabel}
          disabled={disabled}
          onClick={onVoice}
        >
          <Icon name="mic" size="var(--hs-field-icon)" />
        </button>
      ) : null}
    </div>
  );
}
